module.exports = __webpack_public_path__ + "img/el-ic-net.747a002e.svg";